import React from 'react';
import {Stack} from '@mui/material';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import NameInfoBackBarSingleVoyage from "@containers/singleVoyage/views/backBar/nameInfo/NameInfoBackBarSingleVoyage";
import {sx} from './sx'
import ResetTimeIconSvg from "@resource/ResetTimeIconSvg";

const HeaderSidebarMutateSingleVoyage = () => {

    const {
        routeInfo,
    } = useRootContextMutateSingleVoyage()

    return (
        <Stack
            direction={'row'}
            gap={1}
            justifyContent={'space-between'}
            alignItems={'center'}
        >

            <NameInfoBackBarSingleVoyage
                name={routeInfo.title}
                sx={sx.name}
                icon={<ResetTimeIconSvg/>}
                maxNameLength={40}
            />
        </Stack>
    );
};

export default HeaderSidebarMutateSingleVoyage;
